/* @ngInject */
export default function SleuthService($rootScope, $location, $translate, CacheService, AllDefinitionsCacheService, NotifyingService, QueryApiService, UniquePartModelService,
                                      ImageProcessorService) {
    var self = this;
    var _sleuthResult = undefined;
    // Store detectedParameterValues when sleuth return with error message. Do not save on _sluehtResult when error happened.
    var _detectedParameterValues = undefined;

    /**
     * Build Query Param
     * @param childDefinitionIds - The Leaf Definition Ids
     * @param parameterValues - UniquePart Parameters, DefinitionParameters, or QueryParameters
     * @return {{targetDefinitionIds: *, parameterValueIds: Array, parameterIds: Array, values: Array, targetMfgs: [string]}}
     */
    function buildQueryParam(childDefinitionIds, parameterValues) {
        var filteredIds = [];
        var parameterIds = [];
        var values = [];

        parameterValues.forEach(function (value) {
            filteredIds.push(value.id);
            parameterIds.push(value.parameterId);

            var result = undefined;
            // Search created parameter id
            for (var i = 0; i < values.length; ++i) {
                if (values[i].parameterId === value.parameterId) {
                    result = values[i];
                    if (result.oldParameterValueIds === undefined) {
                        result.oldParameterValueIds = [];
                    }
                    break;
                }
            }
            if (result === undefined) {
                result = {
                    parameterId: value.parameterId,
                    parameterValueIds: [],
                    oldParameterValueIds: []
                };
                values.push(result);
            }
            result.parameterValueIds.push(value.id);

            if (_sleuthResult !== undefined &&
                _sleuthResult.queryParameterValues !== undefined) {

                for (var i = 0; i < _sleuthResult.queryParameterValues.length; ++i) {

                    if (_sleuthResult.queryParameterValues[i].parameterId === value.parameterId) {

                        if (result.oldParameterValueIds.indexOf(result.parameterValueIds) === -1) {
                            result.oldParameterValueIds.push(_sleuthResult.queryParameterValues[i].id);
                        }
                    }
                }
            }

        });

        return {
            targetDefinitionIds: childDefinitionIds,
            parameterValueIds: filteredIds,
            parameterIds: parameterIds,
            values: values,
            targetMfgs: []
        };
    }

    /**
     * Get the Current Definition and Store its Parent
     * @param rootDefinition
     * @return {*}
     */
    function getCurrentDefinitionAndStoreParent(rootDefinition) {
        var currentDefinition;
        if (rootDefinition.childDefinitions.length == 1) {
            CacheService.storeParentDefinition(rootDefinition);
            currentDefinition = getCurrentDefinitionAndStoreParent(rootDefinition.childDefinitions[0]);
        } else {
            currentDefinition = rootDefinition;
        }
        return currentDefinition;
    }

    /**
     * Move to a Definition with Children
     * @param rootDefinition
     * @return {*}
     */
    function moveToDefinitionWithChildren(rootDefinition) {
        CacheService.getParentDefinition().length = 0;
        return getCurrentDefinitionAndStoreParent(rootDefinition);
    }

    function createDefinitionParameterQuery(definitionParameter, value) {
        if (definitionParameter.query === undefined) {
            definitionParameter.query = {
                parameterDisplayNames: value.parameterDisplayNames,
                parameterId: value.parameterId,
                parameterName: value.parameterName
            };
        }

        if (definitionParameter.query.selectedFormattedValues === undefined) {
            definitionParameter.query.selectedFormattedValues = [];
        }
    }

    /**
     * Update the Builder Menu Interface
     * @param definitionParameter
     * @param value
     */
    function updateSideMenuUI(definitionParameter, value) {
        if (value.clicked !== undefined && value.clicked) {
            value.clicked = false;
            definitionParameter.query = undefined;
        } else {
            createDefinitionParameterQuery(definitionParameter, value);
            // This is introduced from when we added dynamic filter.
            // Since technology service call fillMenuValue, it is possible builder will have
            // duplicated selectedFormattedValues. selectedFormattedValues should be reset
            // from fillMenuValue but since but it will produce new bug, duplicate check is added
            // on this function. This is not fixing bug, it fix symptom
            var found = false;
            for (var sfvIndex = 0; sfvIndex < definitionParameter.query.selectedFormattedValues.length; ++sfvIndex) {
                if (value.id == definitionParameter.query.selectedFormattedValues[sfvIndex].id) {
                    found = true;
                    break;
                }
            }
            if (!found) {
                definitionParameter.query.selectedFormattedValues.push(value);
            }
        }
    }

    function trimSpaces(str) {
        str = str.replace(/^\s+/, '');
        for (var i = str.length - 1; i >= 0; i--) {
            if (/\S/.test(str.charAt(i))) {
                str = str.substring(0, i + 1);
                break;
            }
        }
        return str;
    }

    /**
     * Close the Message
     * @param result
     * @return {boolean}
     */
    function closeMessage(result) {
        // Show message if there is a part change
        if (result.detectedUniqueParts !== undefined && result.detectedUniqueParts.length === 1) {
            if (CacheService.getOriginalQueryInput() !== undefined && result.detectedUniqueParts[0].displayPn !== trimSpaces(CacheService.getOriginalQueryInput())) {
                return false;
            }
        }

        if (result.detectedUniqueParts !== undefined && result.detectedUniqueParts.length > 1) {
            if (CacheService.getOriginalQueryInput() !== undefined && CacheService.getOriginalQueryInput().indexOf(' ') == -1 && result.detectedUniqueParts[0].displayPn !== trimSpaces(CacheService.getOriginalQueryInput())) {
                return false;
            }
        }

        if (result.message == null || result.message.type.toLocaleLowerCase() == 'info' || result.message.type.toLocaleLowerCase() == 'default') {
            NotifyingService.closeMessageNotification();
            return true;
        }

        // Do not display message if unique part message is modified
        if (result.uniqueParts !== undefined && result.uniqueParts != null && result.uniqueParts.length > 0) {
            if (result.uniqueParts[0].message.type == 'MODIFIED') {
                NotifyingService.closeMessageNotification();
                return true;
            }
        }

        return false;
    }

    /**
     * Replace Asterisks with appropriate tag
     * @param message
     * @return {*}
     */
    function makeBold(message) {
        var closeBold = false;
        while (message.indexOf('*') > 0) {
            if (!closeBold) {
                message = message.replace('*', '<b>');
                closeBold = true;
            } else {
                message = message.replace('*', '</b>');
                closeBold = false;
            }
        }
        return message;
    }

    function addNewline(message) {
        while (message.indexOf('\n') > 0) {
            message = message.replace('\n', '<br/>');
        }
        return message;
    }

    /**
     * Whether it has unique parts
     * @param uniqueParts
     * @return {boolean}
     */
    function hasUniqueParts(uniqueParts) {
        return uniqueParts !== undefined && uniqueParts !== null && uniqueParts.length !== 0;
    }

    /**
     * Notify of a Message Event
     * @param uniqueParts
     * @param alertLevel
     * @param message
     * @param msgId
     */
    function notifyMessage(uniqueParts, alertLevel, message, msgId) {
        if (hasUniqueParts(uniqueParts)) {
            NotifyingService.messageNotification({
                alertLevel: alertLevel,
                message: message,
                msgId: msgId
            });
        } else {
            NotifyingService.messageNotification({
                alertLevel: alertLevel,
                message: message
            });
        }
    }

    /**
     * Cache a message
     * @param uniqueParts
     * @param alertLevel
     * @param message
     * @param msgId
     */
    function cacheMessage(uniqueParts, alertLevel, message, msgId) {
        if (hasUniqueParts(uniqueParts)) {
            CacheService.setMessage({
                alertLevel: alertLevel,
                message: message,
                msgId: msgId
            });
        } else {
            CacheService.setMessage({
                alertLevel: alertLevel,
                message: message
            });
        }
    }

    /**
     * Send a Message to the Front End
     * @param result
     * @param location
     * @param msgId
     */
    function sendMessageToUser(result, location, msgId) {
        if (closeMessage(result)) {
            return;
        }

        if (result.message.type === 'error') {
            var compareQueue = UniquePartModelService.getCompareQueue();
            for (var i = 0; i < compareQueue.length; i++) {
                if (compareQueue[i].type !== undefined) {
                    var index = compareQueue.indexOf(compareQueue[i]);
                    compareQueue.splice(index, 1);
                }
            }
        }

        var message = makeBold(result.message.text);
        message = addNewline(message);

        // Over-ride message if there is a part change
        if (result.detectedUniqueParts !== undefined
            && result.message.type !== 'WARNING'
            && result.message.type !== 'ERROR'
        ) {
            if(result.detectedUniqueParts.length === 1) {
                if (result.detectedUniqueParts[0].displayPn.toUpperCase() !== trimSpaces(CacheService.getOriginalQueryInput().toUpperCase())) {
                    message = $translate.instant('message__changeToPart', {
                        originalPart: CacheService.getOriginalQueryInput(),
                        changedPart: result.detectedUniqueParts[0].displayPn
                    }).valueOf();
                    result.message.type = 'INFO';
                }
            } else {
                if (result.detectedUniqueParts[0].displayPn.toUpperCase() !== trimSpaces(CacheService.getOriginalQueryInput().toUpperCase())) {
                    message = $translate.instant('message__changeToParts', {
                        originalPart: CacheService.getOriginalQueryInput(),
                        changedPart: result.detectedUniqueParts[0].displayPn
                    }).valueOf();
                    result.message.type = 'INFO';
                }
            }
        }

        if (location == undefined || location == $location.path()) {
            notifyMessage(result.uniqueParts, result.message.type.toLocaleLowerCase(), message, msgId);
        } else {
            cacheMessage(result.uniqueParts, result.message.type.toLocaleLowerCase(), message, msgId);
        }
    }

    /**
     * Find a Definition in a List of Definitions
     * @param definition
     * @param definitions
     * @return {*}
     */
    function findDefinition(definition, definitions) {
        for (var i = 0; i < definitions.length; ++i) {
            if (definition.id == definitions[i].id) {
                return definitions[i];
            }
        }
        return undefined;
    }

    function countLeafDefinitions(definition) {
        if (definition == null || (_sleuthResult.detectedDefinitions == null || _sleuthResult.detectedDefinitions.length === 0)) {
            return -1;
        }

        if(definition) {
            return countLeafByChildDefinitions(definition.childDefinitions);
        } else {
            return countLeafByChildDefinitions(_sleuthResult.detectedDefinitions);
        }
    }

    function countLeafByChildDefinitions(childDefinitions) {
        if (childDefinitions.length == 0) {
            return 1;
        }
        var countLeaf = 0;

        for (var i = 0; i < childDefinitions.length; ++i) {
            countLeaf += countLeafByChildDefinitions(childDefinitions[i].childDefinitions);
        }
        return countLeaf;
    }

    function setImageBySeriesOrSetDefault(uniqueParts, availableSeries, definition) {
        if (uniqueParts[0].series !== null || (availableSeries !== null && Array.isArray(availableSeries))) {
            if (uniqueParts[0].series !== null) {
                ImageProcessorService.processImagesAndDefinitions(uniqueParts[0].series, [definition]);
            } else {
                ImageProcessorService.processImagesAndDefinitions(availableSeries, [definition]);
            }
        } else {
            ImageProcessorService.processImagesAndDefinitions(null, [definition]);
        }
    }

    return {
        getSleuthDataFauxPart: function (definitionId, searchLabel) {
            var sleuthData = this.getSleuthData();
            var fauxUniquePart = UniquePartModelService.getFauxUniquePartObj();

            fauxUniquePart.parameterValues = sleuthData.queryParameterValues;

            for (var i = 0; i < sleuthData.queryParameterValues.length; i++) {
                if (sleuthData.queryParameterValues[i].parameterName === 'Series') {
                    fauxUniquePart.series = sleuthData.queryParameterValues[i];
                }
            }

            if (definitionId) {
                fauxUniquePart.definitionId = definitionId;
            }

            fauxUniquePart.uniquePn = 'Search';
            if (searchLabel !== undefined) {
                fauxUniquePart.name = searchLabel;
                fauxUniquePart.displayPn = searchLabel;
                fauxUniquePart.displayName = searchLabel;
                fauxUniquePart.displayNames = [
                    {
                        language: 'ENGLISH',
                        display: searchLabel
                    }];
            } else {
                fauxUniquePart.name = 'Search';
                fauxUniquePart.displayPn = 'Search';
                fauxUniquePart.displayName = 'Search';
                fauxUniquePart.displayNames = [
                    {
                        language: 'ENGLISH',
                        display: 'Search'
                    }];

            }
            // name, displayPn are displayed

            return fauxUniquePart;
        },
        trimWhiteSpace: function (str) {
            return trimSpaces(str);
        },
        /**
         * Cache the Sleuth Data
         * @param sleuthResult
         */
        storeSleuthData: function (sleuthResult) {
            _sleuthResult = sleuthResult;
            NotifyingService.notifyOfSleuthDataCache();
        },

        /**
         * Retrieve the Sleuth Data
         * @return {undefined}
         */
        getSleuthData: function () {
            return _sleuthResult;
        },

        storeErrorDetectedParameterValues: function (detectedParameterValues) {
            _detectedParameterValues = detectedParameterValues;
        },

        getErrorDetectedParameterValues: function () {
            return _detectedParameterValues;
        },

        /**
         * Send a Message to the user
         */
        sendMessageToUser: sendMessageToUser,
        /**
         * Send Message
         * @uses sendMessageToUser
         * @param sleuthResult
         * @param location
         */
        sendMessage: function (sleuthResult, location) {
            sendMessageToUser(sleuthResult, location);
        },
        getTypeMessage: function (type) {
            var message;
            if (type == 'MODIFIED') {
                message = $translate.instant('message__MODIFIED').valueOf();
            } else if (type == 'NON_QUALIFIED') {
                message = $translate.instant('message__NON_QUALIFIED').valueOf();
            } else {
                message = '';
            }
            return message;
        },
        /**
         * Build the Target Definition Ids from the Definition
         * @return {*}
         */
        buildTargetDefinitionIdsFromDefinition: function () {
            var targetDefinitionIds;
            if (CacheService.getDefinition().childDefinitions.length > 0) {
                targetDefinitionIds = this.buildQueryParamTargetDefinitionIds(CacheService.getDefinition().childDefinitions);
            } else {
                targetDefinitionIds = [CacheService.getDefinition().id];
            }
            return targetDefinitionIds;
        },
        /**
         * Build the Query Parameter's Target Definition Ids
         * @param childDefinitions
         * @return {Array}
         */
        buildQueryParamTargetDefinitionIds: function (childDefinitions) {
            var targetDefinitionIds = [];
            childDefinitions.forEach(function (childDefinition) {
                targetDefinitionIds.push(childDefinition.id);
            });
            return targetDefinitionIds;
        },
        // getSeriesImage: getSeriesImage,
        handleImageByUniqueParts: function (uniqueParts, definition) {
            if (uniqueParts.length > 1) {
                setImageBySeriesOrSetDefault(uniqueParts, null, definition);
            } else {
                ImageProcessorService.processImagesAndDefinitions(null, [definition]);
            }

        },
        /**
         * Build the Query Parameters
         */
        buildQueryParam: buildQueryParam,
        /**
         * Build the Query Data - the workhorse of SleuthService
         * @param _sleuthResult
         */
        buildQueryData: function (_sleuthResult, navigateCallBack) {
            var definition;

            if (_sleuthResult.detectedDefinitions === null || _sleuthResult.detectedDefinitions.length === 0) {
                // TODO find out when detectedDefinition is null but queryParameterValues is not null
                if (_sleuthResult.queryParameterValues === null) {
                    sendMessageToUser(_sleuthResult, $location.path());
                } else {
                    if ($location.path() === '/browsing/technology') {
                        sendMessageToUser(_sleuthResult, $location.path(), 'technology:resultsLoc');
                    } else {
                        sendMessageToUser(_sleuthResult, $location.path());
                    }

                    if ($location.path() === '/browsing') {
                        var rootDefinitions = CacheService.getAllDefinitions();
                        var newDefinition;
                        if (CacheService.getParentDefinition().length > 0) {
                            newDefinition = findDefinition(CacheService.getParentDefinition()[0], rootDefinitions);
                        } else {
                            newDefinition = findDefinition(CacheService.getDefinition(), rootDefinitions);
                        }
                        CacheService.getParentDefinition().length = 0;
                        CacheService.storeDefinition(newDefinition);
                    }
                }
                NotifyingService.notifySleuthChangeEvent();
            } else {
                var path;

                if (_sleuthResult.detectedDefinitions !== null && _sleuthResult.detectedDefinitions.length > 1) {
                    definition = {
                        description: '',
                        childDefinitions: _sleuthResult.detectedDefinitions,
                        displayName: 'Components',
                        displayNames: [{language: 'ENGLISH', display: 'Components'}],
                        id: 0,
                        name: 'Components',
                        nameBreadcrumb: 'Components',
                        nameBreadcrumbs: [{language: 'ENGLISH', display: 'Components'}]
                    };
                } else {
                    definition = _sleuthResult.detectedDefinitions[0];
                }
                definition = moveToDefinitionWithChildren(definition);


                if (navigateCallBack) {
                    definition = navigateCallBack(definition);
                }


                if (_sleuthResult.detectedDefinitions !== null && _sleuthResult.detectedDefinitions.length > 1) {
                    ImageProcessorService.processImagesAndDefinitions(null, _sleuthResult.detectedDefinitions);
                } else {
                    /*
                    Take care when reading the function names in this logic, one requests multiple images, and one
                    only requests a single image. This is denoted by the "s" at the end, for plurality.
                     */
                    ImageProcessorService.processImagesAndDefinitions(null, _sleuthResult.detectedDefinitions[0].childDefinitions);
                }

                /*
                Take care when reading the function names in this logic, one requests multiple images, and one
                only requests a single image. This is denoted by the "s" at the end, for plurality.
                 */
                // ImageProcessorService.processImagesAndDefinitions(CacheService.getAllImages(), _sleuthResult.detectedDefinition.childDefinitions);
                if (_sleuthResult.detectedUniqueParts.length > 0) {
                    setImageBySeriesOrSetDefault(_sleuthResult.detectedUniqueParts, _sleuthResult.availableSeries, definition);
                } else {
                    ImageProcessorService.processImagesAndDefinitions(null, [definition]);
                }
                // if (_sleuthResult.detectedSeries !== null && Array.isArray(_sleuthResult.detectedSeries)) {
                //     getSeriesImages(definition, _sleuthResult.detectedSeries, function (seriesImages) {
                //         CacheService.storeSeriesImages(seriesImages);
                //         ImageProcessorService.processImagesAndDefinitions(CacheService.getSeriesImages(), _sleuthResult.rootDefinition);
                //     });
                // } else if (_sleuthResult.uniqueParts.length === 1) {
                //     getSeriesImage(definition, _sleuthResult.uniqueParts[0].series, function (image) {
                //         CacheService.storeSeriesImages([image]);
                //         ImageProcessorService.processImagesAndDefinitions(CacheService.getSeriesImages(), [definition]);
                //     });
                // }

                AllDefinitionsCacheService.setDefinitionParamRange(definition);
                CacheService.storeDefinition(definition);
                var isNotMessageDefault = _sleuthResult.message.type !== 'DEFAULT';

                if (countLeafDefinitions(definition) > 1) {
                    $location.search('pn', null);
                    if (isNotMessageDefault) {
                        sendMessageToUser(_sleuthResult, '/browsing');
                    } else {
                        NotifyingService.closeMessageNotification();
                    }
                    path = '/browsing';
                } else if (_sleuthResult.detectedUniqueParts.length === 1) {

                    CacheService.storeUniquePart(_sleuthResult.detectedUniqueParts[0]);
                    path = '/distributor';
                    $location.search('pn', CacheService.getUniquePart().uniquePn);
                    // We don't need to display this particular message, because it's un-useful.
                    if (isNotMessageDefault) {
                        sendMessageToUser(_sleuthResult, '/distributor');
                    } else if (CacheService.getMessage() === undefined) {
                        NotifyingService.closeMessageNotification();
                    }
                } else {
                    $location.search('pn', null);
                    if (_sleuthResult.detectedUniqueParts.length === 0) {
                        sendMessageToUser(_sleuthResult, '/browsing/technology', 'technology:resultsLoc');
                    } else {
                        if (isNotMessageDefault) {
                            sendMessageToUser(_sleuthResult, '/browsing/technology');
                        } else if (CacheService.getMessage() === undefined) {
                            NotifyingService.closeMessageNotification();
                        }
                    }
                    path = '/browsing/technology';
                }

                $location.path(path).search('search', CacheService.getOriginalQueryInput());
                if ($location.path() !== path) {
                    if (path === '/distributor') {
                        $location.path(path).search('id', null);
                    } else {
                        $location.path(path).search('id', CacheService.getDefinition().id);
                    }
                } else {
                    $location.search('id', CacheService.getDefinition().id);
                }

                NotifyingService.notifySleuthChangeEvent();
            }
        },
        /**
         * Search Parameter Value by Parameter Values
         * @param parameterValues
         * @param callBack
         */
        executeParameterValueSearchByParameterValues: function (parameterValues, callBack) {
            var targetDefinitionIds = this.buildTargetDefinitionIdsFromDefinition();
            this.executeParameterValueSearchByDefinitionIds(targetDefinitionIds, parameterValues, callBack);
        },
        /**
         * Search Parameter Value by Definition Ids
         * @param targetDefinitionIds
         * @param parameterValues
         * @param callBack
         */
        executeParameterValueSearchByDefinitionIds: function (targetDefinitionIds, parameterValues, callBack) {
            var query = this.buildQueryParam(targetDefinitionIds, parameterValues);
            this.executeParameterValueSearchByQuery(query, callBack);
        },
        /**
         * Search Parameter Value by Query
         * @param query
         * @param callBack
         */
        executeParameterValueSearchByQuery: function (query, callBack, queryType) {
            if (query.values.length == 0) {
                this.removeSleuthData();
                callBack();
            } else {
                var self = this;
                QueryApiService.executeParameterValueSearch(query, function (response) {
                    self.storeSleuthData(response);
                    self.buildQueryData(response);
                    callBack(response);
                }, undefined, queryType);
            }
        },
        /**
         * Fill the menu values
         * @param value
         */
        fillMenuValue: function (value) {
            var foundParameterValue;
            if (_sleuthResult !== undefined && _sleuthResult.queryParameterValues !== undefined) {
                foundParameterValue = false;

                for (var i = 0; i < _sleuthResult.queryParameterValues.length; ++i) {
                    if (value.parameterId === _sleuthResult.queryParameterValues[i].parameterId) {

                        for (var j = 0; j < value.parameterValues.length; ++j) {
                            if (value.parameterValues[j].id === _sleuthResult.queryParameterValues[i].id) {
                                updateSideMenuUI(value, value.parameterValues[j]);
                                foundParameterValue = true;
                                value.unknownValue = undefined;
                                break;
                            }
                        }

                        if (!foundParameterValue) {
                            value.unknownValue = _sleuthResult.queryParameterValues[i];
                            if (!value.unknownValue.formattedValue) {
                                value.unknownValue.formattedValue = value.unknownValue.value;
                            }
                        }
                    }
                    // if(foundParameterValue) {
                    //     break;
                    // }
                }
            }

            if ($location.path() != '/browsing' && _sleuthResult !== undefined && Object.keys(_sleuthResult.remainingPossibleValues).length > 0) {
                var remainingParmaeterValues = _sleuthResult.remainingPossibleValues[value.parameterId];

                if (remainingParmaeterValues !== undefined) {

                    var isSelectedParameter = false;
                    if (_sleuthResult.queryParameterValues !== undefined) {
                        for (var i = 0; i < _sleuthResult.queryParameterValues.length; ++i) {
                            if (_sleuthResult.queryParameterValues[i].parameterId === value.parameterId) {
                                isSelectedParameter = true;
                                break;
                            }
                        }
                    }

                    var count = 0;
                    var foundParameter;
                    if (isSelectedParameter) {
                        value.totalRemainingParameterValues = value.parameterValues.length;
                    } else {
                        for (var j = 0; j < value.parameterValues.length; ++j) {
                            foundParameter = false;
                            for (var k = 0; k < remainingParmaeterValues.length; ++k) {
                                if (value.parameterValues[j].id == remainingParmaeterValues[k].id) {
                                    foundParameter = true;
                                    break;
                                }
                            }
                            if (!foundParameter) {
                                value.parameterValues[j].show = false;
                            } else {
                                value.parameterValues[j].show = true;
                                ++count;
                            }
                        }
                        value.totalRemainingParameterValues = count;
                    }
                } else {
                    value.totalRemainingParameterValues = 0;
                }
            } else {
                value.totalRemainingParameterValues = value.parameterValues.length;
            }

        },
        /**
         * Remove Sleuth Data
         * This method acts as a de-constructor
         */
        removeSleuthData: function () {
            if (_sleuthResult !== undefined) {
                var rootDefinitions;
                rootDefinitions = CacheService.getAllDefinitions();
                for (var i = 0; i < CacheService.getParentDefinition().length; ++i) {
                    CacheService.getParentDefinition()[i] = findDefinition(CacheService.getParentDefinition()[i], rootDefinitions);
                    rootDefinitions = CacheService.getParentDefinition()[i].childDefinitions;
                }
                // Special case. User is navigating home after Sleuth Search
                if (CacheService.getDefinition() === undefined && CacheService.getParentDefinition.length === 0) {
                    _sleuthResult = undefined;
                    return;
                }

                // Special case. User is on root definition.
                var definition = findDefinition(CacheService.getDefinition(), rootDefinitions);

                if (definition == undefined) {
                    CacheService.storeDefinition(findDefinition(CacheService.getDefinition(), CacheService.getAllDefinitions()));
                } else {
                    CacheService.storeDefinition(definition);
                }

                _sleuthResult = undefined;
                NotifyingService.notifySleuthChangeEvent();
            }
        },
        createDefinitionParameterQuery: createDefinitionParameterQuery
    };
}
